// src/routes/returnsRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Returns from '../pages/returns/Returns';
import ReturnDetail from '../pages/returns/ReturnDetail';
import ProtectedRoute from '../components/global/ProtectedRoute';

const returnsRoutes = (
    <>
        <Route
            path="/returns"
            element={
                <ProtectedRoute requiredPermission="orders.manage">
                    <Returns />
                </ProtectedRoute>
            }
        />
        <Route
            path="/returns/:id"
            element={
                <ProtectedRoute requiredPermission="orders.manage">
                    <ReturnDetail />
                </ProtectedRoute>
            }
        />
    </>
);

export default returnsRoutes;
